// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"d473117a","52":"bd840d66","71":"96f6dcba","92":"fc94920c","102":"ecb804e1","131":"3e1e727b","269":"79dbb403","701":"dc619e22","768":"e112eedc","822":"21bcf5a4"}[chunkId] + ".chunk.js";
};